import { useFormik } from 'formik';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSyncHazardAssessmentParams } from '../hooks/useSyncHazardAssessmentParams';
import { useGetAreaOptionsDataQuery } from '../services/api';
import { setFilterParams } from '../store/actions/filters';
import { filterSelector } from '../store/selectors/filters';
import { SectionLoader } from './general/Loaders';
import { trackEvent, SELECT_COUNTY } from '../utils/googleAnalytics';
import Select from 'react-select';

export const CountySelection = ({ layerManager }) => {
  const { clearAllLayerVisibility } = layerManager;
  const dispatch = useDispatch();
  const { data, isLoading } = useGetAreaOptionsDataQuery({});
  const filterInfo = useSelector(filterSelector);

  const { filterState } = useSyncHazardAssessmentParams(data);

  const formik = useFormik({
    initialValues: {
      selectedCounty: '',
    },
    onSubmit: values => {
      console.log(values);
    },
  });

  useEffect(() => {
    if (data && filterState && formik.values.selectedCounty !== filterState.selectedCounty) {
      formik.setValues({
        selectedCounty: filterState.selectedCounty || '',
      });
    }
  }, [data, filterState, formik]);

  const prevCountyRef = useRef(filterInfo.selectedCounty);
  useEffect(() => {
    const prevCounty = prevCountyRef.current;
    prevCountyRef.current = filterInfo.selectedCounty;
    if (
      filterInfo.selectedCounty &&
      filterInfo.selectedCounty !== prevCounty &&
      clearAllLayerVisibility
    ) {
      clearAllLayerVisibility();
    }
    // eslint-disable-next-line
  }, [filterInfo.selectedCounty]);

  const sharedClassNames = {
    control: () => 'w-52 rounded-sm border-2 border-slateBlue shadow-none min-h-[2rem] text-base ',
    menu: () => 'z-[1000] bg-white border border-gray-200 mt-1 rounded-sm',
    option: ({ isFocused, isSelected }) =>
      `px-3 py-1 cursor-pointer text-base ${
        isSelected ? 'bg-slateBlue text-white' : isFocused ? 'bg-slateBlue' : 'text-black'
      }`,
    singleValue: () => 'text-black text-base font-medium',
    placeholder: () => 'text-gray-500 text-base font-medium',
  };

  return (
    <div className="mb-4 mt-6 flex flex-col">
      <div className="flex items-center gap-4">
        <div className="flex h-9 w-9 items-center justify-center rounded-full border border-blue bg-teal text-lg font-bold text-blue">
          1
        </div>
        <h3 className="text-lg font-bold">Select County</h3>
      </div>
      {data && !isLoading ? (
        <Select
          id="selectedCounty"
          name="selectedCounty"
          options={data?.counties?.map(c => ({ value: c.id, label: c.name }))}
          value={data?.counties
            ?.map(c => ({ value: c.id, label: c.name }))
            .find(opt => opt.value === formik.values.selectedCounty)}
          onChange={selectedOption => {
            const value = selectedOption?.value || '';
            formik.setFieldValue('selectedCounty', value);
            trackEvent(SELECT_COUNTY, { county: value });
            dispatch(
              setFilterParams({
                selectedCounty: value,
                countySelectedFromAddress: false,
              }),
            );
          }}
          isClearable
          className="react-select-container ml-14 mt-2 self-start"
          classNames={sharedClassNames}
        />
      ) : (
        <SectionLoader />
      )}
    </div>
  );
};
